import { render, staticRenderFns } from "./DateToChannels.vue?vue&type=template&id=c5337e7c&scoped=true&"
import script from "./DateToChannels.vue?vue&type=script&lang=js&"
export * from "./DateToChannels.vue?vue&type=script&lang=js&"
import style0 from "./DateToChannels.vue?vue&type=style&index=0&id=c5337e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5337e7c",
  null
  
)

export default component.exports